import React from 'react';
import { Card, CardHeader, CardBody, CardTitle, Table, Button } from 'reactstrap';

const ClassScheduleCard = ({ 
  schedule, 
  onAttendanceChange, 
  onViewClient 
}) => {
  const hasStudents = schedule.bookings.length > 0;
  const studentCount = schedule.bookings.length;
  const studentText = `${studentCount} alumno${studentCount !== 1 ? "s" : ""}`;
  const availableSlots = schedule.capacity - schedule.bookings.length;

  return (
    <Card className="mb-4">
      <CardHeader
        className={`text-white ${hasStudents ? "bg-success" : "bg-secondary"}`}
      >
        <CardTitle tag="h5">
          {schedule.time_slot} - {schedule.class_type?.name ?? "Sin tipo definido"}
        </CardTitle>
        <small>
          {studentText} {schedule.is_individual ? "· Clase individual" : ""} · {availableSlots} cupos disponibles
          {schedule.coach_name ? ` · Coach: ${schedule.coach_name}` : ""}
        </small>
      </CardHeader>
      <CardBody>
        {hasStudents ? (
          <Table bordered responsive hover>
            <thead className="thead-light">
              <tr>
                <th>#</th>
                <th>Alumno</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {schedule.bookings.map((booking, idx) => (
                <BookingRow
                  key={booking.id}
                  booking={booking}
                  index={idx}
                  onAttendanceChange={onAttendanceChange}
                  onViewClient={onViewClient}
                />
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted">Sin alumnos inscritos para esta clase.</p>
        )}
      </CardBody>
    </Card>
  );
};

const BookingRow = ({ booking, index, onAttendanceChange, onViewClient }) => {
  const hasMedicalCondition = booking.client?.notes;

  const formatDate = (classDate) => {
    if (!classDate) return "-";
    const [year, month, day] = classDate.split("-");
    const localDate = new Date(year, month - 1, day);
    return localDate.toLocaleDateString("es-GT", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  const getStatusText = (status) => {
    const statusMap = {
      attended: "Asistió",
      no_show: "No asistió",
      pending: "Pendiente"
    };
    return statusMap[status] || "Desconocido";
  };

  return (
    <tr style={hasMedicalCondition ? { backgroundColor: "#fff3cd" } : {}}>
      <td>{index + 1}</td>
      <td>
        {booking.client ? (
          <>
            {hasMedicalCondition && (
              <span title="Condición médica" style={{ color: "#dc3545", marginRight: 5 }}>
                ⚕️
              </span>
            )}
            {`${booking.client.first_name ?? ""} ${booking.client.last_name ?? ""}`}
          </>
        ) : (
          "Alumno desconocido"
        )}
      </td>
      <td>{formatDate(booking.class_date)}</td>
      <td>{getStatusText(booking.attendance_status)}</td>
      <td>
        <Button
          size="sm"
          style={{
            backgroundColor: booking.attendance_status === "attended" ? "green" : "white",
            color: booking.attendance_status === "attended" ? "white" : "green",
            borderColor: "green",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "green";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            if (booking.attendance_status !== "attended") {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "green";
            }
          }}
          onClick={() => onAttendanceChange(booking.id, "attended")}
        >
          Asistió
        </Button>{" "}

        <Button
          size="sm"
          style={{
            backgroundColor: booking.attendance_status === "no_show" ? "red" : "white",
            color: booking.attendance_status === "no_show" ? "white" : "red",
            borderColor: "red",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "red";
            e.target.style.color = "white";
          }}
          onMouseLeave={(e) => {
            if (booking.attendance_status !== "no_show") {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "red";
            }
          }}
          onClick={() => onAttendanceChange(booking.id, "no_show")}
        >
          No asistió
        </Button>

        <Button
          onClick={() => onViewClient(booking.client.id)}
          color="info"
          size="sm"
          className="btn-icon btn-link"
        >
          <i className="fa fa-search" />
        </Button>
      </td>
    </tr>
  );
};

export default ClassScheduleCard;
